export const protocol: string = process.env.VUE_APP_API_PROTOCOL;
export const baseDomain: string = process.env.NODE_ENV === 'production'
  ? process.env.VUE_APP_API_BASE_DOMAIN
  : process.env.VUE_APP_API_DEV_DOMAIN;
export const APIURL: string = `${protocol}://${baseDomain}${process.env.VUE_APP_API_V1_ROOT}`;
export const baseURL: string = process.env.VUE_APP_BASE_URL;
